import Temp from "./temp";
function App() {
  return <Temp></Temp>;
}

export default App;
